import React from "react";
import LoginHeader from "./Common/LoginHeader";
import Footer from "./Common/Footer";
import { Link } from "react-router-dom";
import { Component } from "react";
import DocumentMeta from "react-document-meta";
import * as myConstList from "./Common/BaseUrl";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "moment";
import { ImageValidation } from "./Validation/ImageValidation";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import LeftTab from "./Common/LeftTab";
import { ProductName } from "./Common/ProductName";

const baseUrl = myConstList.baseUrl;

export class help extends Component {
  constructor() {
    super();
    this.state = {
      input: {},
      isInputShow: false,
      errors: {},
      userIdData: "",
      BtnDisable: false,
      src: false,
      uploadedFile: null,
      desc: "",
      verifyidpic: "./assets/img/support.jpg",
      messageissueImage: "",
      userUploadImage: "/assets/img/support.jpg",
      btnnDisable: true,
      issueDesc: "",
    };
    this.TicketList();
  }

  TicketList = (event) => {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      },
    };

    axios
      .post(baseUrl + "/frontapi/helplist-by-user", {}, config)
      .then((resp) => {
        var respNew = resp.data;
        this.setState({ resp1: resp.data });

        if (respNew.status === true) {
          this.setState({
            tabledata: respNew.data,
            respStatus: respNew.status,
          });
        }
      });
  };
  responseHtml = () => {
    const html = [];
    if (this.state.respStatus == false) {
      html.push(
        <>
          <div>
            <p className="errorsTag">{this.state.message} </p>
          </div>
        </>
      );
    } else if (this.state.respStatus == true) {
      html.push(
        <>
          <div>
            <p className="succTag">{this.state.message} </p>
          </div>
        </>
      );
    }
    return html;
  };

  helpsbmt = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("userId", localStorage.getItem("jwtToken"));

    if (this.state.issueType === "Others") {
      formData.append("issue", this.state.issue);
    } else {
      formData.append("issue", this.state.issueType);
    }
    formData.append("issueType", this.state.issueDesc);
    formData.append("issueImage", this.state.issueImage);

    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
        "content-type": "multipart/form-data",
      },
    };
    // Validations //
    if (this.state.issueType === "Select Subject") {
      this.setState({ IssueError: "This field is required" });
      return false;
    }
    if (this.state.issueType === "Others") {
      if (this.state.issue === undefined) {
        this.setState({ IssueError: "This field is required" });
        return false;
      }
    }
    if (!this.state.issueDesc) {
      this.setState({ IssueTypeDesc: "This field is required" });
      return false;
    }

    let hasLeadingSpace = /^\s/.test(this.state.issueDesc);
    let hasTrailingSpace = /\s$/.test(this.state.issueDesc);

    if (hasLeadingSpace) {
      this.setState({
        IssueTypeDesc: "Please enter a valid description message",
      });
      return false;
    }

    if (hasTrailingSpace) {
      this.setState({
        IssueTypeDesc: "Please enter a valid description message",
      });
      return false;
    }

    // V end //
    this.setState({ btnnDisable: true });
    setTimeout(() => this.setState({ btnnDisable: false }), 2000);
    axios.post(baseUrl + "/frontapi/help", formData, config).then((resp) => {
      var resp = resp.data;
      if (resp.status === true) {
        toast.dismiss();
        toast.success(resp.message);
        this.TicketList();
      } else {
        toast.dismiss();
        toast.error(resp.message);
      }
      setTimeout(() => window.location.reload(), 2000);
      this.setState({
        BtnDisable: true,
      });
      this.setState({
        message: resp.message,
        respStatus: resp.status,
      });
    });
  };

  onChangeImage = (e) => {
    e.preventDefault();

    this.setState({ issueImage: "", userUploadImage: false });

    var issueImage = e.target.files[0];
    this.setState({ issueImage: e.target.files[0] });
    this.setState({ userUploadImage: URL.createObjectURL(issueImage) });

    let error = ImageValidation("Help", issueImage);

    if (error) {
      this.setState({ message: error, respStatus: false });
      return false;
    }

    this.setState({ message: "", respStatus: true });

    // if (issueImage == false) {
    //   this.setState({ message: "Please select image.", respStatus: false });
    //   return false;
    // }
    // if (!issueImage.name.match(/\.(jpg|jpeg|png)$/)) {
    //   this.setState({
    //     message: "Please select a valid image jpg|jpeg|png.",
    //     respStatus: false,
    //   });
    //   return false;
    // }

    if (e.target.files.length > 0) {
      this.setState({ fileName: e.target.files[0].name });
    }
  };

  handleChange = (event) => {
    let { name, value } = event.target;
    this.setState({ [name]: value });

    if (value === "Select Subject" || !value) {
      this.setState({
        IssueError: "This field is required",
        isInputShow: false,
        btnnDisable: true,
      });
      return false;
    }

    if (value == "Others") {
      this.setState({
        isInputShow: true,
        btnnDisable: false,
        IssueError: "",
      });
    } else {
      this.setState({ IssueError: "", isInputShow: false, btnnDisable: false });
    }
  };

  handleChangeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
    if (name == "issue") {
      var issue = value;
      var IssueError = "";
      if (!issue) {
        IssueError = "This field is required";
        this.setState({ IssueError });
        return false;
      }
      if (value.replace(/\s+/g, "").length == 0) {
        IssueError = "Please enter a valid subject field";
        this.setState({
          IssueError,
        });
        return false;
      }
      if (issue.length > 50) {
        // toast.dismiss();
        IssueError = "Max character limit is 50";
        this.setState({ IssueError });
        return false;
      }
      this.setState({ IssueError });
    }

    if (name === "issueDesc") {
      if (!value) {
        this.setState({
          IssueTypeDesc: "This field is required",
        });
      } else {
        this.setState({ IssueTypeDesc: "" });
      }
    }
  };

  handleOnBlurIssueType(event) {
    var issueType = this.state.desc;
    var IssueTypeError = "";
    if (!issueType) {
    }
    this.setState({
      issueType: issueType,
      messageIssueType: IssueTypeError,
    });
  }

  showTableHtml = () => {
    const USER_ID = this.state.UserID;
    const UserLink = "/UserProfile/" + this.state.UserID;

    if (this.state.respStatus === true) {
      var response = this.state.respp;
      const html = [];
      this.state.tabledata.map((value, i) => {
        var U_ID = value.id;
        var encodeMe = btoa(U_ID);

        const UserLink1 = "/Chatting/" + encodeMe + "/" + value.seenStatus;

        html.push(
          <tr>
            <td>{value.id}</td>
            <td>{value.issue}</td>
            <td>
              {value.status == 0 && "Pending"}
              {value.status == 1 && "Resolved"}
            </td>
            <td>{Moment(value.createAt).format("lll")}</td>
            {value.updateAt ? (
              <td>{Moment(value.updateAt).format("lll")}</td>
            ) : (
              <td></td>
            )}
            <td
              className={
                value.status == 0 && value.seenStatus == "1"
                  ? "position-relative chat-count"
                  : ""
              }
            >
              <Link className="btn btn_man" to={UserLink1}>
                {" "}
                {value.status == 0 ? "Chat" : "View"}
              </Link>
              <span className="position-absolute">
                {value.seenStatus == "1" ? "*" : ""}
              </span>
            </td>
          </tr>
        );
      });

      return html;
    }
  };

  render() {
    const meta = {
      title: `Support | ${ProductName} Exchange`,
      description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
      meta: {
        charset: "utf-8",
        name: {
          keywords: `${ProductName} Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
        },
      },
    };
    return (
      <DocumentMeta {...meta}>
        <div>
          <LoginHeader />
          <div className="bghwhite">
            <div className="new_inpage">
              <div className="container container2">
                <LeftTab />
                <h4 className="mb-3">Support</h4>
                <div className="row">
                  <div className="col-md-6">
                    <div className="white_box h_100">
                      <div className=" ">
                        <div className="form-group">
                          <label className="fw-500">Subject</label>
                          <select
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.issueType}
                            name="issueType"
                            id="issueType"
                          >
                            <option>Select Subject</option>
                            <option value="Exchange">Exchange</option>
                            <option value="Login">Login</option>
                            <option value="Signup">Signup</option>
                            <option value="Kyc">KYC</option>
                            <option value="Account">Account</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                        <div className="form-group">
                          {this.state.isInputShow == true && (
                            <>
                              <label className="fw-500">Other Subject</label>
                              <input
                                className="form-control"
                                name="issue"
                                id="issue"
                                placeholder="Enter Subject"
                                onChange={this.handleChangeInput}
                                value={this.state.issue}
                              />
                            </>
                          )}
                          <span style={{ color: "red" }}>
                            {this.state.IssueError}
                          </span>
                          {/* <span style={{ color: "red" }}>
                          {this.state.IssueTypeError}
                        </span> */}
                        </div>

                        <div className="form-group">
                          <label className="fw-500"> Description </label>

                          <textarea
                            name="issueDesc"
                            value={this.state.issueDesc}
                            onChange={this.handleChangeInput}
                            className="form-control form_control_textarea"
                            placeholder="Enter Issue Type"
                            id="issueDesc"
                          />

                          {/* <CKEditor
                            editor={ClassicEditor}
                            name="issueType"
                            value={this.state.issueType}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              this.setState({ desc: data }, () => {
                                if (!this.state.desc) {
                                  this.setState({
                                    IssueTypeError: "This field is required",
                                  });
                                } else {
                                  this.setState({ IssueTypeError: "" });
                                }
                              });
                            }}
                            className="form-control form_control_textarea"
                            placeholder="Enter Issue Type"
                            id="IssueType"
                          /> */}
                        </div>
                        <span style={{ color: "red" }}>
                          {this.state.IssueTypeDesc}
                        </span>

                        <div className="form-group">
                          <div className=" col-md-6">
                            <label className="fw-500">Attachment</label>

                            <div className="uploader">
                              <input
                                className="profile_input"
                                type="file"
                                name="issueImage"
                                id="file-upload"
                                onChange={this.onChangeImage}
                              />
                              <label for="file-upload" id="file-drag">
                                <img
                                  src={
                                    this.state.userUploadImage !== false
                                      ? this.state.userUploadImage
                                      : this.state.verifyidpic
                                  }
                                  className="img-fluid22 support-img"
                                  alt="Identity"
                                />
                                <div id="start">
                                  <span className="fasi"></span>
                                  <div>Upload image</div>
                                  <div id="notimage" className="hidden">
                                    Please select an image
                                  </div>
                                </div>
                                <div id="response" className="hidden">
                                  <div id="messages">
                                    <span style={{ color: "red" }}>
                                      {this.state.message}
                                    </span>
                                  </div>
                                  <progress
                                    className="progress"
                                    id="file-progress"
                                    value="0"
                                  >
                                    <span>0</span>%
                                  </progress>
                                </div>
                              </label>

                              <div id="messages">
                                <span style={{ color: "red" }}>
                                  {this.state.message}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* 
                          <div className="add_fileinput">
                            Add File
                            <input
                              className="profile_input"
                              type="file"
                              name="issueImage"
                              onChange={this.onChangeImage}
                            />
                          </div>






                          <label>
                            <img
                              src={
                                this.state.userUploadImage !== false
                                  ? this.state.userUploadImage
                                  : this.state.verifyidpic
                              }
                              className="img-fluid22 support-img"
                              alt="Identity"
                            />
                          </label> */}
                        </div>

                        <div className="form-group">
                          <input
                            onClick={this.helpsbmt}
                            type="submit"
                            value="Submit"
                            className="btn w100px btn_man "
                            disabled={this.state.btnnDisable}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="white_box h_100 ticket-history">
                      <h6>Ticket History</h6>
                      <div className="table-responsive ticket-history-outer">
                        <div className="scrool_wallet_box">
                          <table className="table table-striped mb-0">
                            <thead>
                              <tr>
                                <th>Ticket Id</th>
                                <th>Subject</th>
                                <th>Status</th>
                                <th>Created At</th>
                                <th>Last Updated</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>{this.showTableHtml()}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
          
        </div>
      </DocumentMeta>
    );
  }
}

export default help;
